import { ApiModuleType, ACCountModuleType } from "../@types/api";
const api: ApiModuleType & ACCountModuleType = {
  add: {
    url: "/account/add",
    method: "post",
  },
  list: {
    url: "/account/list",
    method: "get",
  },
  delete: {
    url: "/account/delete",
    method: "post",
  },
  info: {
    url: "/account/info",
    method: "get",
  },
  update: {
    url: "/account/update",
    method: "post",
  },
}
export default api;